export const LOCAL_STORAGE_SYSTEM_PREFIX = "@umbrella-fc";
